
export default function LabelValue({ label, value }) {
   return <div>
      <div className="text-sm text-gray-500">
         {label}
      </div>
      <div className="text-lg text-gray-600">
         {value}
      </div>
   </div>
}